import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import { Empty, Spin } from 'antd';

import { compose } from '../../../core';
import { getIntFromString } from '../functions';

import SelectField from './SelectField';
import {
  withLookOrganizationFilterUpdating,
  withLookOrganizationState,
  withLookVerticalFilterUpdating
} from '../../containers/LookOperations';

const ALL_ORGANIZATION_QUERY = gql`
  query allOrganization($first: Int, $orderBy: [String], $name_Icontains: String) {
    allOrganization(first: $first, orderBy: $orderBy, name_Icontains: $name_Icontains) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const OrganizationAutoComplete = props => {
  const { loading, allOrganization, margin = true, onOrganizationNameChange, onOrganizationChange, onFiltersRemove } = props;
  const handleFilterRemove = React.useRef(() => {});

  handleFilterRemove.current = () => {
    onFiltersRemove();
  };

  React.useEffect(() => {
    return () => handleFilterRemove.current();
  }, []);

  const choices =
    allOrganization &&
    allOrganization.edges.length > 0 &&
    allOrganization.edges.map(({ node }) => ({ label: node.name || '', value: Number(getIntFromString(node.id)) }));

  return (
    <SelectField
      margin={margin}
      showSearch
      choices={choices}
      style={{ width: !margin && 200, marginBottom: !margin && 0 }}
      onChange={e => Number.isInteger(e) && onOrganizationChange(e)}
      // labelInValue
      filterOption={false}
      onSearch={onOrganizationNameChange}
      notFoundContent={
        loading ? (
          <div align="center">
            <Spin size="small" />
          </div>
        ) : (
          <Empty />
        )
      }
      {...props}
    />
  );
};

export default compose(
  withLookOrganizationState,
  graphql(ALL_ORGANIZATION_QUERY, {
    options: ({ filter, orderBy, pagination }) => {
      return { variables: { ...pagination, ...filter, orderBy } };
    },
    props({ data }) {
      const { loading, error, allOrganization, subscribeToMore, updateQuery } = data;
      return { loading, error, allOrganization, subscribeToMore, updateQuery };
    }
  }),
  withLookOrganizationFilterUpdating,
  withLookVerticalFilterUpdating
)(OrganizationAutoComplete);
